var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible && _vm.$route.name !== "login"
    ? _c("div", { staticClass: "unauthorized-pop-up-container" }, [
        _c(
          "div",
          {
            staticClass: "dialog-box",
            attrs: {
              "data-aos": "fade-up",
              "data-aos-anchor-placement": "center-bottom",
              "data-aos-duration": "800"
            }
          },
          [
            _c("div", { staticClass: "dialog-box-content" }, [
              _c("h4", { staticClass: "dialog-box-title" }, [
                _vm._v(_vm._s(_vm.$t("common.yourSessionHasExpired")) + "!")
              ]),
              _c("p", { staticClass: "dialog-box-message" }, [
                _c("span", { staticClass: "dialog-box-title clock" }, [
                  _vm._v(_vm._s(_vm.time))
                ])
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }